import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { Watch } from "@/types/watches";

const watchesKey = ["watches"] as const;

export function useWatches() {
  return useQuery({
    queryKey: watchesKey,
    queryFn: () => api.get<Watch[]>("/api/watches"),
  });
}

export function useCancelWatch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/api/watches/${id}/cancel`),
    onSuccess: () => qc.invalidateQueries({ queryKey: watchesKey }),
  });
}
